const TarAdmin = resolve => require(['@/components/tarAdmin/index.vue'], resolve);
const ReviewManage = resolve => require(['@/components/tarAdmin/reviewManage/index.vue'], resolve);
const BankManage = resolve => require(['@/components/tarAdmin/bankManage/index.vue'], resolve);
const PaperManage = resolve => require(['@/components/tarAdmin/paperManage/index.vue'], resolve);
const ActivityManage = resolve => require(['@/components/tarAdmin/activityManage/index.vue'], resolve);
// 精准复习-运营端路由
const tarAdminRouter = [
  {
    path: '/tarAdmin/home',
    name: 'TarAdmin',
    component: TarAdmin,
  },
  // 复习包管理
  {
    path: '/tarAdmin/review',
    name: 'ReviewManage',
    redirect: '/tarAdmin/reviewPackage',
    component: ReviewManage,
    children: [
      {
        path: '/tarAdmin/reviewPackage',
        name: 'reviewPackage',
        component: () => import('@/components/tarAdmin/reviewManage/reviewPackage.vue'),
      },
      {
        path: '/tarAdmin/sourceConfig',
        name: 'sourceConfig',
        component: () => import('@/components/tarAdmin/reviewManage/sourceConfig/sourceConfig.vue'),
      },
      {
        path: '/tarAdmin/saveSource',
        name: 'saveSource',
        component: () => import('@/components/tarAdmin/reviewManage/sourceConfig/saveSource.vue'),
      },
    ]
  },
  // 习题配置
  {
    path: '/tarAdmin/exerConfig',
    name: 'exerConfig',
    component: () => import('@/components/tarAdmin/reviewManage/exerConfig/exerConfig.vue'),
    meta: {keepAlive: true, level: 1},
    beforeEnter(to, from, next) {
      // 如果是从特定页面进入那么所有条件应该重置
      if (from.path === '/tarAdmin/reviewPackage') {
        to.params.clear = true;
        to.params.componentName = 'exerConfig';
      }
      next()
    }
  },
  {
    path: '/tarAdmin/exerBankView',
    name: 'exerBankView',
    component: () => import('@/components/tarAdmin/common/exerBankView.vue'),
    meta: {keepAlive: true, level: 1},
    beforeEnter(to, from, next) {
      // 如果是从特定页面进入那么所有条件应该重置
      if (from.path === '/tarAdmin/bank' || from.path === '/tarAdmin/exerConfig' || from.meta.isCreate === true) {
        to.params.clear = true;
        to.params.componentName = 'taradminExerBankView';
      }
      next()
    }
  },
  {
    path: '/tarAdmin/exerAdd',
    name: 'exerAddCommon',
    component: () => import('@/components/tarAdmin/common/exerAddCommon.vue'),
  },
  // 试题篮
  {
    path: '/exerBank/exerBasket',
    name: 'exerBasket',
    component: () => import('@/components/tarAdmin/common/exerBasket.vue'),
  },
  {
    path: '/tarAdmin/manuallyPaper',
    name: 'ManuallyPaper',
    component: () => import('@/components/preciseReview/evaluationManagement/manuallyPaper.vue'),
  },
  {
    path: '/tarAdmin/editPaperExercise',
    name: 'tarAdminEditPaperExercise',
    component: () => import('@/components/preciseReview/evaluationManagement/editPaperExercise.vue'),
  },
  // 题库管理
  {
    path: '/tarAdmin/bank',
    name: 'BankManage',
    component: BankManage,
    meta: {keepAlive: true, level: 1},
    beforeEnter(to, from, next) {
      // 如果是从特定页面进入那么所有条件应该重置
      if (from.path === '/tarAdmin/home' || from.path === '/tarAdmin/testPaperDetail') {
        to.params.clear = true;
        to.params.componentName = 'TarAdminBankManage';
      }
      next()
    }
  },
  // 试卷管理
  {
    path: '/tarAdmin/paper',
    name: 'PaperManage',
    component: PaperManage,
  },
  // 活动管理
  {
    path: '/tarAdmin/activity',
    name: 'ActivityManage',
    component: ActivityManage,
  },
  // 活动管理/试卷管理-试卷详情
  {
    path: '/tarAdmin/testPaperDetail',
    name: 'testPaperDetail',
    component: () => import('@/components/tarAdmin/common/testPaper/testPaperDetail.vue'),
  },
  {
    path: '/traAdmin/testAutoPaper',
    name: 'testAutoPaper',
    component: () => import('@/components/tarAdmin/common/testPaper/testAutoPaper.vue'),
  },
  // 活动管理-测评信息-查阅
  {
    path: '/tarAdmin/activityConsult',
    name: 'tarAdminActivityConsult',
    component: () => import('@/components/tarAdmin/activityManage/testPaperConsultIndex.vue'),
  },
  // 活动管理-测评信息-学生查阅
  {
    path: '/tarAdmin/activityStudentConsult',
    name: 'tarAdminActivityStudentConsult',
    component: () => import('@/components/tarAdmin/activityManage/testPaperStudentConsultIndex.vue'),
  },
  // 活动管理-测评信息-批阅
  {
    path: '/tarAdmin/activityReview',
    name: 'tarAdminActivityReview',
    component: () => import('@/components/tarAdmin/activityManage/testPaperReviewIndex.vue'),
  },
]

export default tarAdminRouter;



// WEBPACK FOOTER //
// ./src/router/tar_admin.js